export default {"src":"/_next/static/media/minimal-processing.68916470.svg","height":71,"width":69,"blurWidth":0,"blurHeight":0};